import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Logo from "../assets/checkLogo.png"

export default function Login({ setToken }) {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);
  const [shake, setShake] = useState(false);

  const handleSubmit = async e => {
    try {
      e.preventDefault();
      setLoading(true);
      const loginResponse = await loginUser({ email, password });
      if (!loginResponse.token) {
        setLoading(false);
        setShake(true);
        setTimeout(() => setShake(false), 600);
        alert(loginResponse.message);
      } else {
        console.log("Logged in", loginResponse.token);
        setToken(loginResponse);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      alert("Something went wrong");
    }
  };

  async function loginUser(credentials) {
    return fetch(process.env.REACT_APP_ADMIN + "/login/signIn", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(credentials)
    }).then(data => data.json());
  }

  return (
    <>
      <style>{styles}</style>

      <div className="login-root">
        {/* Ambient orbs */}
        <div className="login-orb login-orb1" />
        <div className="login-orb login-orb2" />
        <div className="login-orb login-orb3" />

        {/* Animated dot grid background */}
        <div className="login-grid" />

        {/* Floating decorative RFID/QR shapes */}
        <div className="login-deco login-deco1">
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
            <rect x="1" y="1" width="58" height="58" rx="8" stroke="rgba(232,27,35,0.3)" strokeWidth="1.5"/>
            <rect x="10" y="10" width="16" height="16" rx="2" stroke="rgba(232,27,35,0.5)" strokeWidth="1.2"/>
            <rect x="34" y="10" width="16" height="16" rx="2" stroke="rgba(232,27,35,0.5)" strokeWidth="1.2"/>
            <rect x="10" y="34" width="16" height="16" rx="2" stroke="rgba(232,27,35,0.5)" strokeWidth="1.2"/>
            <rect x="34" y="34" width="7" height="7" fill="rgba(232,27,35,0.4)"/>
            <rect x="44" y="34" width="6" height="6" fill="rgba(232,27,35,0.25)"/>
            <rect x="34" y="44" width="6" height="6" fill="rgba(232,27,35,0.25)"/>
          </svg>
        </div>
        <div className="login-deco login-deco2">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect x="1" y="1" width="46" height="32" rx="5" stroke="rgba(232,27,35,0.25)" strokeWidth="1.2"/>
            <rect x="7" y="12" width="12" height="14" rx="2" stroke="rgba(232,27,35,0.4)" strokeWidth="1"/>
            <line x1="7" y1="17" x2="19" y2="17" stroke="rgba(232,27,35,0.3)" strokeWidth="0.8"/>
            <line x1="7" y1="21" x2="19" y2="21" stroke="rgba(232,27,35,0.3)" strokeWidth="0.8"/>
            <path d="M26 16c3 0 5 2 5 4s-2 4-5 4" stroke="rgba(232,27,35,0.5)" strokeWidth="1.2" strokeLinecap="round"/>
            <path d="M26 11c6 0 10 4 10 9s-4 9-10 9" stroke="rgba(232,27,35,0.3)" strokeWidth="1" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="login-deco login-deco3">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            <circle cx="20" cy="20" r="19" stroke="rgba(232,27,35,0.2)" strokeWidth="1"/>
            <circle cx="20" cy="20" r="12" stroke="rgba(232,27,35,0.3)" strokeWidth="1"/>
            <circle cx="20" cy="20" r="5" fill="rgba(232,27,35,0.35)"/>
          </svg>
        </div>

        {/* Login card */}
        <div className={`login-card ${shake ? 'login-shake' : ''}`}>
          {/* Card top accent line */}
          <div className="login-card-topline" />

          {/* Logo */}
          <div className="login-logo-wrap">
            <img
              // src="https://www.nyuctech.com/images/logo.png"
              src={Logo}
              alt="NYUC"
              className="login-logo"
            />
          </div>

          <h1 className="login-heading">Welcome</h1>
          <p className="login-subheading">Sign in to your account</p>

          <form className="login-form" onSubmit={handleSubmit}>
            {/* Email field */}
            <div className="login-field-wrap">
              <div className="login-field-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <input
                className="login-input"
                required
                type="email"
                placeholder="Email address"
                name="email"
                onChange={e => setEmail(e.target.value)}
              />
            </div>

            {/* Password field */}
            <div className="login-field-wrap">
              <div className="login-field-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/>
                  <path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <input
                className="login-input"
                required
                type="password"
                placeholder="Password"
                name="password"
                onChange={e => setPassword(e.target.value)}
              />
            </div>

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? (
                <span className="login-spinner" />
              ) : (
                <>
                  <span>Sign In</span>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

Login.propTypes = {
  setToken: PropTypes.func.isRequired
};

/* ─── All styles inline so Login.css is no longer needed ─── */
const styles = `
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .login-root {
    position: fixed;
    inset: 0;
    background: linear-gradient(160deg, #0a0a0f 0%, #12121a 40%, #0d0d15 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  }

  /* ── Dot grid ── */
  .login-grid {
    position: fixed;
    inset: 0;
    background-image: radial-gradient(rgba(232,27,35,0.12) 1px, transparent 1px);
    background-size: 36px 36px;
    pointer-events: none;
    z-index: 0;
    mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 30%, transparent 100%);
    -webkit-mask-image: radial-gradient(ellipse 80% 80% at 50% 50%, black 30%, transparent 100%);
  }

  /* ── Ambient orbs ── */
  .login-orb {
    position: fixed;
    border-radius: 50%;
    pointer-events: none;
    z-index: 0;
  }
  .login-orb1 {
    top: -15%; left: -10%;
    width: 600px; height: 600px;
    background: radial-gradient(circle, rgba(232,27,35,0.18) 0%, rgba(232,27,35,0.04) 50%, transparent 70%);
    filter: blur(8px);
    animation: orbFloat1 12s ease-in-out infinite;
  }
  .login-orb2 {
    bottom: -20%; right: -10%;
    width: 700px; height: 700px;
    background: radial-gradient(circle, rgba(180,10,18,0.14) 0%, rgba(120,0,10,0.05) 50%, transparent 70%);
    filter: blur(12px);
    animation: orbFloat2 16s ease-in-out infinite;
  }
  .login-orb3 {
    top: 40%; left: 30%;
    width: 400px; height: 400px;
    background: radial-gradient(circle, rgba(255,80,80,0.06) 0%, transparent 70%);
    filter: blur(20px);
    animation: orbFloat3 20s ease-in-out infinite;
  }

  /* ── Floating deco shapes ── */
  .login-deco {
    position: fixed;
    pointer-events: none;
    z-index: 1;
    opacity: 0.6;
  }
  .login-deco1 { top: 12%; left: 8%;  animation: decoFloat 8s ease-in-out infinite; }
  .login-deco2 { bottom: 14%; right: 7%; animation: decoFloat 10s ease-in-out infinite reverse; }
  .login-deco3 { top: 60%; left: 12%; animation: decoFloat 12s ease-in-out infinite 2s; }

  /* ── Login card ── */
  .login-card {
    position: relative;
    z-index: 10;
    width: min(420px, 90vw);
    background: rgba(14,14,20,0.88);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 24px;
    padding: 40px 40px 36px;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    box-shadow: 0 8px 64px rgba(0,0,0,0.7), 0 0 0 1px rgba(255,255,255,0.04), inset 0 1px 0 rgba(255,255,255,0.06);
    animation: cardReveal 0.7s cubic-bezier(0.22, 1, 0.36, 1);
  }

  /* Top red accent line */
  .login-card-topline {
    position: absolute;
    top: 0; left: 10%; right: 10%;
    height: 2px;
    background: linear-gradient(90deg, transparent, #e81b23, rgba(232,27,35,0.5), #e81b23, transparent);
    border-radius: 2px;
    animation: accentPulse 3s ease-in-out infinite;
  }

  /* Logo */
  .login-logo-wrap {
    display: flex;
    justify-content: center;
    margin-bottom: 24px;
  }
  .login-logo {
    width: 280px;
    filter: drop-shadow(0 0 16px rgba(232,27,35,0.4));
    animation: logoGlow 4s ease-in-out infinite;
  }

  .login-heading {
    text-align: center;
    color: #f0f0f5;
    font-size: 1.7rem;
    font-weight: 800;
    letter-spacing: 0.03em;
    text-shadow: 0 0 30px rgba(232,27,35,0.4);
    margin-bottom: 6px;
  }
  .login-subheading {
    text-align: center;
    color: rgba(180,180,200,0.45);
    font-size: 0.82rem;
    letter-spacing: 0.07em;
    margin-bottom: 32px;
  }

  /* ── Form ── */
  .login-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .login-field-wrap {
    position: relative;
    display: flex;
    align-items: center;
  }
  .login-field-icon {
    position: absolute;
    left: 14px;
    color: rgba(180,180,200,0.4);
    display: flex;
    align-items: center;
    pointer-events: none;
    transition: color 0.3s ease;
  }
  .login-field-wrap:focus-within .login-field-icon {
    color: #e81b23;
  }
  .login-input {
    width: 100%;
    background: rgba(255,255,255,0.07);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    color: #f0f0f5;
    font-size: 0.95rem;
    padding: 13px 16px 13px 42px;
    outline: none;
    transition: all 0.3s ease;
  }
  .login-input::placeholder { color: rgba(180,180,200,0.35); }
  .login-input:hover {
    background: rgba(255,255,255,0.1);
    border-color: rgba(232,27,35,0.35);
  }
  .login-input:focus {
    background: rgba(232,27,35,0.06);
    border-color: #e81b23;
    box-shadow: 0 0 0 3px rgba(232,27,35,0.12);
  }

  /* ── Submit button ── */
  .login-btn {
    margin-top: 8px;
    width: 100%;
    padding: 14px 24px;
    background: #e81b23;
    border: none;
    border-radius: 12px;
    color: #fff;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    box-shadow: 0 4px 20px rgba(232,27,35,0.4);
    transition: all 0.3s cubic-bezier(0.22, 1, 0.36, 1);
    position: relative;
    overflow: hidden;
  }
  .login-btn::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.18), transparent);
    background-size: 200% 100%;
    background-position: -200% center;
    transition: background-position 0.45s ease;
  }
  .login-btn:hover:not(:disabled) {
    background: #c8121a;
    transform: translateY(-2px) scale(1.01);
    box-shadow: 0 8px 32px rgba(232,27,35,0.55);
  }
  .login-btn:hover::after { background-position: 200% center; }
  .login-btn:active:not(:disabled) { transform: translateY(0) scale(1); }
  .login-btn:disabled { opacity: 0.7; cursor: not-allowed; }

  /* Loading spinner */
  .login-spinner {
    width: 18px;
    height: 18px;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: #fff;
    border-radius: 50%;
    animation: spin 0.7s linear infinite;
    display: inline-block;
  }

  /* Shake on error */
  .login-shake {
    animation: shake 0.55s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  /* ── Keyframes ── */
  @keyframes orbFloat1 {
    0%, 100% { transform: translate(0,0) scale(1); }
    33%  { transform: translate(60px,-80px) scale(1.15); }
    66%  { transform: translate(-40px,40px) scale(0.9); }
  }
  @keyframes orbFloat2 {
    0%, 100% { transform: translate(0,0) scale(1); }
    33%  { transform: translate(-70px,50px) scale(1.1); }
    66%  { transform: translate(50px,-60px) scale(0.95); }
  }
  @keyframes orbFloat3 {
    0%, 100% { transform: translate(0,0) scale(1); }
    50%  { transform: translate(40px,60px) scale(1.2); }
  }
  @keyframes decoFloat {
    0%, 100% { transform: translateY(0px) rotate(0deg); }
    50%  { transform: translateY(-14px) rotate(4deg); }
  }
  @keyframes cardReveal {
    from { opacity: 0; transform: translateY(32px) scale(0.97); }
    to   { opacity: 1; transform: translateY(0) scale(1); }
  }
  @keyframes accentPulse {
    0%, 100% { opacity: 0.45; transform: scaleX(0.65); }
    50%  { opacity: 1; transform: scaleX(1); }
  }
  @keyframes logoGlow {
    0%, 100% { filter: brightness(1) drop-shadow(0 0 0px rgba(232,27,35,0)); }
    50%  { filter: brightness(1.1) drop-shadow(0 0 12px rgba(232,27,35,0.45)); }
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  @keyframes shake {
    10%, 90%  { transform: translateX(-2px); }
    20%, 80%  { transform: translateX(4px); }
    30%, 50%, 70% { transform: translateX(-6px); }
    40%, 60%  { transform: translateX(6px); }
    100% { transform: translateX(0); }
  }

  @media (max-width: 480px) {
    .login-card { padding: 32px 24px 28px; }
    .login-heading { font-size: 1.4rem; }
    .login-deco1, .login-deco2, .login-deco3 { display: none; }
  }
`;